import { CustomSource } from "../../models/CustomSource";
import { defaultStrokeColor } from "../../utils/map-utils";

const sourceName = CustomSource.QueryInfrastructure;
const source: mapboxgl.GeoJSONSourceSpecification = {
  type: "geojson",
  promoteId: "id",
  data: {
    type: "FeatureCollection",
    features: [],
  },
};

const fillLayer: mapboxgl.FillLayerSpecification = {
  type: "fill",
  paint: {
    "fill-opacity": 0.1,
    "fill-color": "#12d3c4",
  },
  source: sourceName,
  id: `${sourceName}-fill`,
};

const lineLayer: mapboxgl.LineLayerSpecification = {
  type: "line",
  paint: {
    "line-opacity": 0.5,
    "line-color": "#047067",
  },
  source: sourceName,
  id: `${sourceName}-line`,
};

const isLineString = ["==", "$type", "LineString"];
const isRouteSelected = ["boolean", ["get", "selected"], false];
const originDestinationSource = CustomSource.ImportHlaAtoB;
const routeLineLayer: mapboxgl.LineLayerSpecification = {
  type: "line",
  layout: {
    "line-join": "round",
    "line-cap": "round",
  },
  paint: {
    "line-width": 5,
    "line-color": ["case", isRouteSelected, "#10a1d6", "#3b8ca9"],
  },
  source: originDestinationSource,
  id: `${originDestinationSource}-line`,
  filter: isLineString,
};

const routeStrokeLayer: mapboxgl.LineLayerSpecification = {
  type: "line",
  layout: {
    "line-join": "round",
    "line-cap": "round",
  },
  paint: {
    "line-width": 7,
    "line-color": ["case", isRouteSelected, "#1c4cec", "#3d57ad"],
  },
  source: originDestinationSource,
  id: `${originDestinationSource}-stroke`,
  filter: isLineString,
};

const isPoint = ["==", "$type", "Point"];
const originDestinationLayer: mapboxgl.CircleLayerSpecification = {
  id: `${originDestinationSource}-point`,
  type: "circle",
  source: originDestinationSource,
  paint: {
    "circle-radius": 8,
    "circle-color": ["get", "color"],
    "circle-opacity": 0.8,
  },
  filter: isPoint,
};

const originDestinationStrokeLayer: mapboxgl.CircleLayerSpecification = {
  id: `${originDestinationSource}-point-stroke`,
  type: "circle",
  source: originDestinationSource,
  paint: {
    "circle-radius": 9,
    "circle-color": defaultStrokeColor,
  },
  filter: isPoint,
};

const originDestinationTextLayer: mapboxgl.SymbolLayerSpecification = {
  id: `${originDestinationSource}-text`,
  type: "symbol",
  source: originDestinationSource,
  layout: { "text-field": ["get", "text"], "text-size": 14 },
  paint: {
    "text-color": "#ffffff",
  },
  filter: isPoint,
};

const parkingLayer: mapboxgl.CircleLayerSpecification = {
  type: "circle",
  paint: {
    "circle-radius": 7,
    "circle-opacity": 0,
    "circle-color": "transparent",
  },
  id: CustomSource.Parking,
  source: "composite",
  "source-layer": "poi_label",
  filter: ["==", "type", "Parking"],
};

const busStopLayer: mapboxgl.CircleLayerSpecification = {
  type: "circle",
  paint: {
    "circle-radius": 7,
    "circle-opacity": 0,
    "circle-color": "transparent",
  },
  id: CustomSource.BusStop,
  source: "composite",
  "source-layer": "transit_stop_label",
};

const osmDataSourceName = CustomSource.OsmData;
const osmDataSource: mapboxgl.GeoJSONSourceSpecification = {
  type: "geojson",
  data: {
    type: "FeatureCollection",
    features: [],
  },
};

const osmLineLayer: mapboxgl.LineLayerSpecification = {
  type: "line",
  paint: {
    "line-opacity": 0.5,
    "line-width": 2,
    "line-color": "#0078f0",
  },
  source: osmDataSourceName,
  id: `${osmDataSourceName}-line`,
};

export const importHlaMapConfig = {
  sourceName,
  source,
  originDestinationSource,
  busStopLayer,
  parkingLayer,
  originDestinationTextLayer,
  originDestinationStrokeLayer,
  originDestinationLayer,
  routeStrokeLayer,
  lineLayer,
  routeLineLayer,
  fillLayer,
  osmDataSourceName,
  osmDataSource,
  osmLineLayer,
};
